"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { toggleSaveTradesperson } from "@/app/actions/saved";

export function SaveButton({
  tradespersonId,
  initialSaved,
  isLoggedIn,
  isHomeowner,
  size = "md",
}: {
  tradespersonId: string;
  initialSaved: boolean;
  isLoggedIn: boolean;
  isHomeowner: boolean;
  size?: "sm" | "md";
}) {
  const [saved, setSaved] = useState(initialSaved);
  const [loading, setLoading] = useState(false);
  const router = useRouter();

  async function handleToggle(e: React.MouseEvent) {
    e.preventDefault();
    e.stopPropagation();

    if (!isLoggedIn) {
      router.push("/signup/homeowner");
      return;
    }

    if (!isHomeowner) return;

    setLoading(true);
    const result = await toggleSaveTradesperson(tradespersonId);
    if ("saved" in result && typeof result.saved === "boolean") {
      setSaved(result.saved);
    }
    setLoading(false);
  }

  const sizeClasses =
    size === "sm"
      ? "w-8 h-8"
      : "w-10 h-10";
  const iconSize = size === "sm" ? "w-4 h-4" : "w-5 h-5";

  return (
    <button
      type="button"
      onClick={handleToggle}
      disabled={loading}
      aria-label={saved ? "Remove from saved" : "Save tradesperson"}
      className={`${sizeClasses} rounded-full flex items-center justify-center transition-all ${
        saved
          ? "bg-copper/10 text-copper hover:bg-copper/20"
          : "bg-cream text-text-muted hover:bg-stone/40 hover:text-copper"
      } disabled:opacity-50`}
    >
      <svg
        className={iconSize}
        viewBox="0 0 24 24"
        fill={saved ? "currentColor" : "none"}
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
        />
      </svg>
    </button>
  );
}
